export const ValidateEmail = (value) => {
  // var mailformat = /^[A-Za-z][\w$.]+@[\w]+\.\w+$/;
  var mailformat = /^[A-Za-z][\w$.]+@[\w]+\.[A-Za-z]{2,}(?:\.[A-Za-z]+)?$/;
  if (mailformat.test(value)) {
    return "Valid Email";
  } else {
    return "Invalid Email";
  }
};
